import { render } from "./DocsView.vue?vue&type=template&id=2410974e&scoped=true"
import script from "./DocsView.vue?vue&type=script&lang=js"
export * from "./DocsView.vue?vue&type=script&lang=js"

import "./DocsView.vue?vue&type=style&index=0&id=2410974e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2410974e"]])

export default __exports__